import { useCallback, useSyncExternalStore } from "react";

const STORAGE_EVENT = "storage";

export function usePersistentString(
  key: string,
  fallback: string,
): [string, (next: string) => void] {
  const getSnapshot = useCallback(
    () => window.localStorage.getItem(key) ?? fallback,
    [key, fallback],
  );

  const value = useSyncExternalStore(subscribe, getSnapshot, () => fallback);

  const setValue = useCallback(
    (next: string) => {
      window.localStorage.setItem(key, next);
      window.dispatchEvent(new Event(STORAGE_EVENT));
    },
    [key],
  );

  return [value, setValue];
}

function subscribe(onStoreChange: () => void): () => void {
  window.addEventListener(STORAGE_EVENT, onStoreChange);
  return () => window.removeEventListener(STORAGE_EVENT, onStoreChange);
}
